export default __webpack_public_path__ + "static/media/Group 141.47973d5b.svg";